
// Dropdown and mega menu

const ddButtons = document.getElementsByClassName("mob-parent-button");

// Loop through each button
for (const ddButton of ddButtons) {
  // Add a click event listener to the button
  ddButton.addEventListener("click", function (event) {
    // Prevent the default behavior of the button click
    event.preventDefault();
    // Find the next sibling element and add the "active" class to it
    const nextElement = ddButton.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      updateSlHideVisibility();
    }
  });
}

const ddPanels = document.getElementsByClassName("mob-secondary-level-ul");

// Function to update the visibility of sl-hide divs
function updateSlHideVisibility() {
  const isActivePanel = Array.from(ddPanels).some(panel => panel.classList.contains("active"));
  const slHideDivs = document.getElementsByClassName("sl-hide");

  for (const slHideDiv of slHideDivs) {
    if (isActivePanel) {
      slHideDiv.classList.add("sl-hide-oi");
    } else {
      slHideDiv.classList.remove("sl-hide-oi");
    }
  }
}

// Loop through each panel
for (const ddPanel of ddPanels) {
  // Find the "nav-secondary-fo-back-button" within the current panel
  const backButton = ddPanel.querySelector(".nav-secondary-fo-back-button");

  // Add a click event listener to the back button
  backButton.addEventListener("click", function () {
    // Remove the "active" class from the parent panel
    ddPanel.classList.toggle("active");
    updateSlHideVisibility();
  });

  // Create a MutationObserver for each panel
  const panelObserver = new MutationObserver(() => {
    updateSlHideVisibility();
  });

  // Define what to observe within the panel for specific changes
  const observerConfig = { subtree: true, childList: true, attributes: true, characterData: true };

  // Start observing the panel for changes
  panelObserver.observe(ddPanel, observerConfig);
}


const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel');
const gcHeader = document.querySelector('.header-bar-inner');

function applyBackgroundColor() {
  gcHeader.classList.add('hovered');
}

function removeBackgroundColor() {
  gcHeader.classList.remove('hovered');
}

navDesktopButtons.forEach((navDesktopButton) => {
  navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
  navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
});

headerMegaFwLists.forEach((headerMegaFwList) => {
  headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
  headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
});


// Scrolling transition for transparent header option

const headerDiv = document.getElementById('SiteHeader');
let isScrolled = false;
let lastScrollPosition = 0; // To track the last known scroll position

window.addEventListener('scroll', function () {
  const scrollThreshold = 50;
  const header = document.querySelector('.header-bar');
  const scrollPosition = window.scrollY;
  const screenWidth = window.innerWidth;
  if (screenWidth > 950) return;

  if (scrollPosition > scrollThreshold) {
    if (scrollPosition > lastScrollPosition) {
      // Scrolling down
      header.classList.add('scrolled');
    } else {
      // Scrolling up
      header.classList.remove('scrolled');
      header.classList.add('scrolling-up');
    }
  } else {
    // Scrolling ended top
    header.classList.remove('scrolling-up');
  }

  if (scrollPosition > scrollThreshold && !isScrolled) {
    headerDiv.classList.remove('hdr-trans-hp');
    isScrolled = true;
  } else if (scrollPosition <= scrollThreshold && isScrolled) {
    headerDiv.classList.add('hdr-trans-hp');
    isScrolled = false;
  }

  lastScrollPosition = scrollPosition;
});


// Menu drawer

var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtn = document.getElementById('hdrMenuBtn');
var navclose = document.getElementById('mobNavDrawerClose');

//if (navbtn) {
//  navbtn.addEventListener('click', function() {
//    navdrawermobile.classList.toggle('open');
//    navclose.focus();
//    drawbg.classList.toggle('open');
//    event.preventDefault();
//  });
//}


// Function to open the menu drawer and set focus to the close button
function openMenuDrawer(event) {
  navdrawermobile.classList.toggle('open');
  drawbg.classList.toggle('open');
  if (navdrawermobile.classList.contains('open')) {
    setTimeout(() => {
      navclose.focus();
    }, 200); // Adjust the delay time as needed to match the transition duration
  }
  event.preventDefault();
}

// Check if navbtn exists and is an element
if (navbtn) {
  // Click event listener
  navbtn.addEventListener('click', openMenuDrawer);

  // Keydown event listener for 'Enter' key
  navbtn.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      openMenuDrawer(event);
    }
  });
}

if (navclose) {
  navclose.addEventListener('click', function () {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    navbtn.focus();
  });
}

if (drawbg) {
  drawbg.addEventListener('click', function () {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    navbtn.focus();
  });
}

// Mobile navigation second-level menu
const accordionButtons = document.querySelectorAll('.accordion-button');

if (accordionButtons) {
  accordionButtons.forEach(button => {
    button.addEventListener('click', function () {
      const accordionContent = this.nextElementSibling;

      // Toggle the display of the accordion content
      accordionContent.classList.toggle('show');

      if (accordionContent.style.maxHeight) {
        accordionContent.style.maxHeight = null;
      } else {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      }

      const iconOpen = this.querySelector('.accordion-icon-open');
      const iconClose = this.querySelector('.accordion-icon-close');

      if (accordionContent.classList.contains('show')) {
        iconOpen.style.display = 'none';
        iconClose.style.display = 'block';
      } else {
        iconOpen.style.display = 'block';
        iconClose.style.display = 'none';
      }
    });
  });
}
